<template>
    <div class="p-3 bg-white border-light">
        <h5 class="mb-3 text-uppercase font-weight-bold">{{ title }}</h5>
        <template v-for="f in fields">
            <p class="mb-0" v-if="f.type === 'bool'">
                <span class="font-weight-bold">{{ f.title ? f.title + ": " : "" }}</span>
                <i class="fa fa-fw" :class="dataSource[f.prop] ? 'fa-check' : 'fa-times'"></i>
            </p>
            <p class="mb-0" v-else-if="f.type === 'date'">
                <span class="font-weight-bold">{{ f.title ? f.title + ": " : "" }}</span>
                {{ dataSource[f.prop] ? moment(dataSource[f.prop]).format("MM/DD/YYYY") : "" }}
            </p>
            <p class="mb-0" v-else-if="f.type === 'select-multiple'">
                <span class="font-weight-bold">{{ f.title ? f.title + ": " : "" }}</span>
                <span
                    v-if="f.options"
                    class="comma-list"
                    v-for="selectedOption in dataSource[f.prop]"
                >
                    {{
                        f.options.find(l => l.value === selectedOption)
                            ? f.options.find(l => l.value === selectedOption).title
                            : ""
                    }}
                </span>
                <span v-else="" class="comma-list" v-for="selectedOption in dataSource[f.prop]">{{
                    l
                }}</span>
            </p>
            <p class="mb-0" v-else-if="f.displayProp">
                <span class="font-weight-bold">{{ f.title ? f.title + ": " : "" }}</span>
                <span class="comma-list" v-for="displayProp in f.displayProp">
                    {{ dataSource[displayProp] }}
                </span>
            </p>
            <p class="mb-0" v-else="">
                <span class="font-weight-bold">{{ f.title ? f.title + ": " : "" }}</span
                >{{ dataSource[f.prop] }}
            </p>
        </template>
        <button
            v-if="actionTitle"
            class="mt-2 px-0 btn btn-link text-primary text-uppercase font-weight-bold"
            @click="editData()"
        >
            {{ actionTitle }} &gt;
        </button>
        <modal-component
            :id="`modal-${title.replace(/\s+/g, '')}`"
            :title="title"
            :visible="visible"
            @close="resetModal()"
        >
            <div class="p-3">
                <multi-field
                    v-for="f in fields"
                    v-if="!f.noInput"
                    :key="`${parentKey || ''}-${f.prop}`"
                    :name="f.prop"
                    :type="f.type"
                    :title="f.title"
                    :options="f.options"
                    v-model="payload[f.prop]"
                ></multi-field>
                <button
                    v-if="fields.filter(f => !f.noInput).length"
                    class="btn btn-sm btn-primary text-uppercase font-weight-bold text-white float-right"
                    @click="saveData()"
                >
                    Save
                </button>
                <slot></slot>
            </div>
        </modal-component>
    </div>
</template>

<script>
import ModalComponent from "./ModalComponent";
import MultiField from "./MultiField";
export default {
    name: "DataDumpWidget",
    components: { ModalComponent, MultiField },
    props: ["title", "dataSource", "payload", "parentKey", "fields", "actionTitle", "endpoint"],
    data() {
        return {
            visible: false,
        };
    },
    watch: {
        visible() {
            if (this.visible) {
            }
        },
    },
    methods: {
        emitAction() {
            this.$emit("action");
        },
        editData() {
            this.$emit("edit-data");
            this.visible = true;
        },
        treatPayload(payload) {
            Object.keys(payload).forEach(k => {
                const field = this.fields.find(f => f.prop === k);
                if (field) {
                    if (field.type === "date" && field.prop === "dob") {
                        // Formats dates for DB
                        payload[field.prop] = this.moment(payload[field.prop]).format("YYYY-MM-DD");
                    } else if (field.type === "date") {
                        payload[field.prop] = this.moment(payload[field.prop]).format(
                            "YYYY-MM-DD HH:mm:ss"
                        );
                    }
                    if (Array.isArray(payload[field.prop])) {
                        // Replaces objects with their IDs
                        if (payload[field.prop].length) {
                            if (payload[field.prop][0].hasOwnProperty("id")) {
                                payload[field.prop] = payload[field.prop].map(o => o.id);
                            }
                        }
                    }
                }
            });
            payload = this.cleanEmptyProperties(payload);
            return payload;
        },
        cleanEmptyProperties(payload) {
            Object.keys(payload).forEach(k => {
                if (!(payload[k] === 0) && !payload[k]) {
                    delete payload[k];
                }
            });
            return payload;
        },
        saveData() {
            let payload = this.treatPayload({ ...this.payload });
            axios
                .patch(this.endpoint, payload)
                .then(r => {
                    this.$emit("data-saved");
                    this.resetModal();
                })
                .catch(e => {
                    this.$emit("save-error", e);
                });
        },
        resetModal() {
            this.visible = false;
            this.$emit("reset");
        },
    },
};
</script>

<style scoped></style>
